export enum BiquadType
{
  LowPass,
  BandPass,
  HighPass,
  Peak,
  LowShelf,
  HighShelf,
  Notch,
  AllPass
}

export class Biquad
{

  a0 = 0;
  a1 = 0;
  a2 = 0;
  a3 = 0;
  a4 = 0;

  x1 = 0;
  x2 = 0;
  y1 = 0;
  y2 = 0;

  process( inputSample:number )
  {
    let result =  this.a0 * inputSample + 
                  this.a1 * this.x1 + 
                  this.a2 * this.x2 -
                  this.a3 * this.y1 - 
                  this.a4 * this.y2;

    this.x2 = this.x1;
    this.x1 = inputSample;

    this.y2 = this.y1;
    this.y1 = result;

    return result;
  }

  public static create( filterType:BiquadType, gainDB:number, frequency:number, bandwidth:number, sampleRate:number )
  {
    var filter = new Biquad();
    let A= 0, omega= 0, sn= 0, cs= 0, alpha= 0, beta = 0;
    let a0= 0, a1= 0, a2= 0, b0= 0, b1= 0, b2 = 0;

    let M_LN2 = 0.69314718055994530942;

    A = Math.pow( 10, gainDB / 40 );
    omega = 2 * Math.PI * frequency / sampleRate;
    sn = Math.sin( omega );
    cs = Math.cos( omega );
    alpha = ( sn * Math.sinh( M_LN2 / 2 * bandwidth * omega / sn ) );
    beta = Math.sqrt(A + A);

    switch ( filterType ) 
    {        
      
      case BiquadType.LowPass:
      {
        b0 = (1 - cs) /2;
        b1 = 1 - cs;
        b2 = (1 - cs) /2;
        a0 = 1 + alpha;
        a1 = -2 * cs;
        a2 = 1 - alpha;
      }
      break;

      case BiquadType.HighPass:
      {
        b0 = (1 + cs) /2;
        b1 = -(1 + cs);
        b2 = (1 + cs) /2;
        a0 = 1 + alpha;
        a1 = -2 * cs;
        a2 = 1 - alpha;
      }
      break;

      case BiquadType.BandPass:
      {
        b0 = alpha;
        b1 = 0;
        b2 = -alpha;
        a0 = 1 + alpha;
        a1 = -2 * cs;
        a2 = 1 - alpha;
      }
      break;

      case BiquadType.Notch:
      {
        b0 = 1;
        b1 = -2 * cs;
        b2 = 1;
        a0 = 1 + alpha;
        a1 = -2 * cs;
        a2 = 1 - alpha;
      }
      break;
          
      case BiquadType.Peak:
      {
        b0 = 1 + (alpha * A);
        b1 = -2 * cs;
        b2 = 1 - (alpha * A);
        a0 = 1 + (alpha /A);
        a1 = -2 * cs;
        a2 = 1 - (alpha /A);
      }
      break;

      case BiquadType.LowShelf:
      {
        b0 = A * ((A + 1) - (A - 1) * cs + beta * sn);
        b1 = 2 * A * ((A - 1) - (A + 1) * cs);
        b2 = A * ((A + 1) - (A - 1) * cs - beta * sn);
        a0 = (A + 1) + (A - 1) * cs + beta * sn;
        a1 = -2 * ((A - 1) + (A + 1) * cs);
        a2 = (A + 1) + (A - 1) * cs - beta * sn;
      }
      break;

      case BiquadType.HighShelf:
      {
        b0 = A * ((A + 1) + (A - 1) * cs + beta * sn);
        b1 = -2 * A * ((A - 1) + (A + 1) * cs);
        b2 = A * ((A + 1) + (A - 1) * cs - beta * sn);
        a0 = (A + 1) - (A - 1) * cs + beta * sn;
        a1 = 2 * ((A - 1) - (A + 1) * cs);
        a2 = (A + 1) - (A - 1) * cs - beta * sn;
      }
      break;


    }

    filter.a0 = b0 / a0;
    filter.a1 = b1 / a0;
    filter.a2 = b2 / a0;
    filter.a3 = a1 / a0;
    filter.a4 = a2 / a0;

    filter.x1 = filter.x2 = 0;
    filter.y1 = filter.y2 = 0;

    return filter;
  }

  public static filter( inputSample:number, coefficients:number[], buffer:number[] ):number
  {
    
    let result =  coefficients[ 0 ] * inputSample + 
                  coefficients[ 1 ] * buffer[ 0 ] + 
                  coefficients[ 2 ] * buffer[ 1 ] -
                  coefficients[ 3 ] * buffer[ 2 ] - 
                  coefficients[ 4 ] * buffer[ 3 ];

    buffer[ 1 ] = buffer[ 0 ];
    buffer[ 0 ] = inputSample;

    buffer[ 3 ] = buffer[ 2 ];
    buffer[ 2 ] = result;      

    return result;
  }
}